import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "border-b border-gray-lp-1400 w-full p-4 flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-xl text-gray-lp-300" }, " Edit Area ", -1)
const _hoisted_3 = { class: "flex flex-col gap-4 p-4" }
const _hoisted_4 = {
  key: 0,
  class: "p-2 flex flex-row items-center rounded-md bg-yellow-lp-400 gap-x-2 text-gray-lp-300"
}
const _hoisted_5 = { class: "font-bold " }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" belum memiliki area dan dedicated kurir. ")
const _hoisted_7 = { class: "flex flex-row gap-x-4" }
const _hoisted_8 = { class: "w-1/3" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "w-2/5" }
const _hoisted_11 = { class: "overflow-auto max-h-108" }
const _hoisted_12 = { class: "flex justify-end w-full px-6 py-4 shadow border-t border-gray-lp-400 gap-6" }
const _hoisted_13 = { class: "w-36" }
const _hoisted_14 = { class: "w-48" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AreaNameInput = _resolveComponent("AreaNameInput")!
  const _component_GeoAddressTreeSelector = _resolveComponent("GeoAddressTreeSelector")!
  const _component_AssignCourier = _resolveComponent("AssignCourier")!
  const _component_DynamicShift = _resolveComponent("DynamicShift")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.visible = $event)),
    persistent: "",
    customBody: "p-0",
    showOverflow: false,
    customWidth: "w-4/5"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("img", {
          src: require(`@/app/ui/assets/svg/x.svg`),
          class: "w-6 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false)),
          alt: "close"
        }, null, 8, ["src"])
      ])
    ]),
    "main-footer": _withCtx(() => [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_LpButton, {
            color: "white",
            textColor: "red-lp-100",
            title: "Batal",
            customClass: "border border-red-lp-100",
            outline: "",
            isWidthFull: "",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.visible = false))
          })
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_LpButton, {
            color: "red-lp-100",
            textColor: "white",
            title: "Simpan",
            isWidthFull: "",
            onClick: _ctx.updateArea,
            disabled: _ctx.disableButton
          }, null, 8, ["onClick", "disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_3, [
        (_ctx.unassigned > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("img", {
                src: require('@/app/ui/assets/svg/warning-circle.svg'),
                alt: "info-circle"
              }, null, 8, ["src"]),
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.unassigned) + " kelurahan", 1),
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_AreaNameInput, {
              modelValue: _ctx.form.areaName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.areaName = $event)),
              onValidation: _cache[3] || (_cache[3] = (val) => _ctx.nameValidationError = val)
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_GeoAddressTreeSelector, {
              options: _ctx.geoAddress,
              modelValue: _ctx.form.geoAddressIds,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.geoAddressIds = $event)),
              shipmentType: _ctx.getShipmentType
            }, null, 8, ["options", "modelValue", "shipmentType"])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_AssignCourier, {
              isShiftEnabled: _ctx.isShiftEnabled,
              "onUpdate:isShiftEnabled": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShiftEnabled = $event)),
              selectedCourier: _ctx.selectedCourier,
              "onUpdate:selectedCourier": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedCourier = $event))
            }, null, 8, ["isShiftEnabled", "selectedCourier"])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_DynamicShift, {
            isShiftEnabled: _ctx.isShiftEnabled,
            onShiftsChange: _ctx.setShiftValue,
            onValidateError: _cache[7] || (_cache[7] = (val) => _ctx.isNotErrorShift = val),
            existingShift: _ctx.existingShift
          }, null, 8, ["isShiftEnabled", "onShiftsChange", "existingShift"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}